export default {"src":"/_next/static/media/TikTok.c7206242.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};